import React from 'react';
import { Carousel } from 'primereact/carousel';
import SvgIcon from "@Components/icons/SvgIcon";
import { AppRouteURL } from "@Constants/app-route-url.constant";
import './RecommendedPracticeSlider.scss';

interface RecommendedPracticeSliderProps {
    popularTests: any[];
    checkSubscriptionAndNavigate: (url: string) => void;
}

export const RecommendedPracticeSlider: React.FC<RecommendedPracticeSliderProps> = ({ popularTests, checkSubscriptionAndNavigate }) => {
    const responsiveOptions = [
        {
            breakpoint: '3000px',
            numVisible: 4,
            numScroll: 4
        },
        {
            breakpoint: '1400px',
            numVisible: 3,
            numScroll: 3
        },
        {
            breakpoint: '1024px',
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    const renderCard = (test: any) => {
        return (
            <div className="exam-card tw-h-full">
                <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-overflow-hidden tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-shadow-xl tw-h-full tw-flex tw-flex-col">
                    {/* Image */}
                    <div className="exam-card-img tw-w-full tw-relative" style={{ /*aspectRatio: '16/9',*/ overflow: 'hidden' }}>
                        <img
                            src={test.testSeriesImage || require("@Assets/img/newNoimage.png")}
                            alt={test.testSeriesName}
                            className="tw-bg-gray-100 tw-w-full tw-h-full tw-object-cover"
                            onError={(e: any) => { e.currentTarget.src = require("@Assets/img/newNoimage.png"); }}
                        />
                    </div>
                    {/* Content */}
                    <div className="py-2 px-3 tw-flex tw-flex-col tw-flex-grow">
                        <h3 className="tw-font-semibold tw-mb-2 tw-text-[20px] tw-text-gray-800 tw-line-clamp-2" style={{ overflow: 'hidden' }}>
                            {test.testSeriesName}
                        </h3>

                        <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-1 tw-mb-4 tw-text-[14px] tw-text-gray-500">
                            <span className="tw-whitespace-nowrap">{test.Questions} Questions</span>
                            <span>•</span>
                            <span className="tw-whitespace-nowrap">{Math.floor(test.Time / 60)} Mins</span>
                            <span>•</span>
                            <span className="tw-whitespace-nowrap">Diff: {test.difficultyLevel}</span>
                        </div>

                        <div className="tw-flex tw-justify-between tw-items-center tw-mt-auto tw-mb-2">
                            <button
                                className="tw-text-violet-500 tw-font-semibold hover:tw-underline tw-text-sm tw-flex tw-items-center tw-gap-1 tw-text-[12px]"
                                onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.MOCKTEST_SERIES}/${test.testSeriesId}`)}
                            >
                                Improve This Topic <span
                                    className="tw-w-4 tw-h-4 tw-rounded-full tw-bg-violet-500 tw-text-white tw-flex tw-items-center tw-justify-center "
                                >
                                    <SvgIcon name="rightUpArrow" size={8} />
                                </span>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const itemTemplate = (test: any) => {
        return (
            <div className="recommended-item-wrapper" key={test.testSeriesId}>
                {renderCard(test)}
            </div>
        );
    };

    return (
        <div className="recommended-practice-outer-container">
            {popularTests.length > 3 ? (
                <Carousel
                    value={popularTests}
                    // numVisible={4}
                    // numScroll={4}
                    responsiveOptions={responsiveOptions}
                    circular={true}
                    autoplayInterval={0}
                    showIndicators={false}
                    showNavigators={true}
                    itemTemplate={itemTemplate}
                    className="practice-slider-component"
                />
            ) : (
                <div className="recommended-practice-grid">
                    {popularTests.map((test) => (
                        <div className="recommended-grid-item" key={test.testSeriesId}>
                            {renderCard(test)}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

